import { ApiState, createCachedApiReducer } from '../../../utils/api-state';
import { combineReducers, createFeatureSelector } from '@ngrx/store';
import { AutoPayResponse } from '../models/accounts-notifications.model';
import { getAutoPayActions } from './accounts-notifications.action';

export interface AccountsNotificationState {
  autoPay: ApiState<AutoPayResponse[]>;
}

export const accountNotificationReducer = combineReducers<AccountsNotificationState>({
  autoPay: createCachedApiReducer(getAutoPayActions),
});

export const createAccountsNotificationState = createFeatureSelector<any>('accountsNotification');
